const wowApp = require('angular').module('wowApp.shop');

wowApp.service('SpecialsGroupsService', ['Restangular', '$rootScope', '$q', 'hyphenateFilter', 'ShopperService', '$state', 'BootstrapService', require('./specials-groups-service')]);

wowApp.directive('wowSpecialsGroups', ['$state', '$timeout', '$location', 'SpecialsGroupsService', 'BreakpointsService', 'hyphenateFilter', 'MoveFocus', require('./specials-groups-directive')]);

wowApp.directive('wowSpecialsGroupsV2', ['$state', '$timeout', '$location', 'SpecialsGroupsService', 'BreakpointsService', 'hyphenateFilter', '$anchorScroll', 'MoveFocus', require('./specials-groups-directive-v2')]);

wowApp.directive('wowSpecialsGroupProducts', ['SettingsService', 'SpecialsGroupsService', require('./specials-group-products-directive')]);

wowApp.directive('wowSpecialsNavigation', ['CategoriesService', '$state', '$timeout', 'SpecialsGroupsService', 'ShopperService', 'BreakpointsService', 'SettingsService', 'SettingsByBreakpointService', 'MoveFocus', 'FeatureService', 'PageMetadataService', require('./specials-navigation-directive')]);

wowApp.directive('wowSpecialsNavigationV2', ['CategoriesService', '$state', '$timeout', 'SpecialsGroupsService', 'ShopperService', 'BreakpointsService', 'SettingsService', 'SettingsByBreakpointService', 'MoveFocus', 'PageMetadataService', require('./specials-navigation-directive-v2')]);

wowApp.directive('wowSpecialsGroupDisplay', ['SpecialsGroupsService', require('./specials-group-display-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/index.js
 **/